import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { LawsService } from '../../../../services/api/general-settings/laws.service';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';

@Component({
  selector: 'app-laws-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './laws-index-page.component.html',
  styleUrl: './laws-index-page.component.scss'
})
export class LawsIndexPageComponent {
 list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected lawsService: LawsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Laws',
      cardTitle: 'Manage Laws',
      addNewItemButton: {
        type: 'success',
        title: 'Add Law',
        onClick: () => {
          this.routeService.lawsCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'jurisdictionId',
            header: 'Jurisdiction',
            filter: 'select',
            filterOptionsSource: 'jurisdictions',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'validityStartDate',
            header: 'Start Date',
            filter: 'date',
            value: (item: any) => {
              return item.validityStartDate;
            }
          }),
          new DataTableColumnText({
            attribute: 'validityEndDate',
            header: 'End Date',
            filter: 'date',
            value: (item: any) => {
              return item.validityEndDate;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View law details',
                onClick: (item: any) => {
                  this.routeService.lawsDetail(item.lawId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit law',
                onClick: (item: any) => {
                  this.routeService.lawsUpdate(item.lawId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete law',
                onClick: (item: any) => {

                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.lawsService.list(options),
      responseListModelName: 'laws',
    }
  }
}
